export class ApiError extends Error {
  readonly status: number;
  readonly code: string;

  constructor(status: number, code: string, title: string) {
    super(title);
    this.name = 'ApiError';
    this.status = status;
    this.code = code;
  }
}

/** The service answered 406 `invalid_or_expired_jwt`; the caller must return to login. */
export class SessionExpiredError extends ApiError {
  constructor() {
    super(406, 'invalid_or_expired_jwt', 'Your session has expired');
    this.name = 'SessionExpiredError';
  }
}

/** The response was 2xx but did not match the schema this app was built against. */
export class ContractError extends Error {
  constructor(path: string, detail: string) {
    super(`Unexpected response from ${path}: ${detail}`);
    this.name = 'ContractError';
  }
}
